import { useMemo } from 'react';
import { HorizontalSlideInOut, StepComponent, Takeover, useFlowStep, useTranslation } from '@helios/frontend-core';
import ManufacturerSelectionStep from './Steps/ManufacturerSelectionStep';
import OAuthConnectStep from './Steps/OAuthConnectStep';

type ConnectSolarSystemStepNames = 'select-manufacturer' | 'oauth-connect';

const INITIAL_STEP = 'select-manufacturer';
const TRACKING_ID = 'connect-solar-system-takeover';

interface ConnectSolarSystemTakeoverProps {
  isOpen: boolean;
  onDismiss: () => void;
}

const ConnectSolarSystemTakeover = ({ isOpen, onDismiss }: ConnectSolarSystemTakeoverProps) => {
  const { t } = useTranslation();

  const stepsMap: StepComponent<ConnectSolarSystemStepNames>[] = useMemo(
    () => [
      {
        stepName: 'select-manufacturer',
        component: ManufacturerSelectionStep,
        props: {},
      },
      {
        stepName: 'oauth-connect',
        component: OAuthConnectStep,
        props: {},
      },
    ],
    [],
  );

  const { activeStepContext, setStep } = useFlowStep(stepsMap, INITIAL_STEP, {
    onComplete: onDismiss,
  });

  const handleDismiss = () => {
    setStep(INITIAL_STEP);
    onDismiss();
  };

  const memoizedStep = useMemo(() => {
    return <activeStepContext.component />;
  }, [activeStepContext.stepName]);

  return (
    <Takeover
      isOpen={isOpen}
      onClose={handleDismiss}
      trackingId={TRACKING_ID}
      heading={t('connectSolarSystem.takeover.heading')}
      topNavProps={{
        leftButton: {
          onClick: onDismiss,
          text: t('common.cancel'),
        },
      }}
    >
      <div className="flex flex-col h-full overflow-scroll">
        <HorizontalSlideInOut direction={activeStepContext.direction || 'forward'}>
          {memoizedStep}
        </HorizontalSlideInOut>
      </div>
    </Takeover>
  );
};

export default ConnectSolarSystemTakeover;
